import axios from "axios";
import React, {Component} from "react";
import { Link } from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import Listprint from "../../Listprint";
import Section from "./Section";
import { Helmet } from 'react-helmet';
import { toast } from "react-toastify";

class Trash extends Component{

    state = {
        rowstudents : [],
        rowstaffs : [],
        rowparents : [],
        rowsuppliers : [],
        rowsprofiles : [],
        error : "",
        loading : true,
        columns : [
            {
                label: 'Matricule',
                field: 'matricule',
                sort: 'asc',
                width: 50
            },
            {
                label: "Nom",
                field: 'name',
                sort: 'asc',
                width: 200
            },
            {
                label: 'Classe',
                field: 'classe',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Date',
                field: 'updated_at',
                sort: 'asc',
                width: 120
            },
            {
                label: '',
                field: 'action',
                sort: 'disabled',
                width: 120,
                printable: false
            }
        ]
    }

    async componentDidMount(){
        await this.refresh()
    }

    refresh = async () => {
        this.setState({ loading: true, error: "" })
        const results = await Promise.allSettled([
            this.getDatastudents(), this.getDataparentfamilies(), this.getDatastaffs(),
            this.getDatasuppliers(), this.getDataprofiles()
        ])
        const failures = results.filter((result) => result.status === "rejected").length
        this.setState({ loading: false, error: failures ? "Certaines catégories n’ont pas pu être chargées." : "" })
    }

    formatDate = (value) => {
        const date = value ? new Date(value) : null
        return !date || Number.isNaN(date.getTime()) ? "Date inconnue" : new Intl.DateTimeFormat("fr-FR", { day: "2-digit", month: "short", year: "numeric" }).format(date)
    }

    async getDatastudents(){
        var data = await axios.get("students/operation/Supprimer");
        if(data.status === 200)
        {
            var rows = [];
            data.data.map((student) => {
                var commitment_date = this.formatDate(student.updatedAt);
                var last_name = student.user ? student.user.last_name : "";
                var first_name = student.user ? student.user.first_name : "";
                var family_name = student.user ? student.user.family_name : "";
                rows.push(
                    {
                        id: student.id,
                        matricule : student.user ? (<Link to={'/students/'+student.id}  className="text-decoration-none">{student.matricule || "Non renseigné"}</Link>) : "Non renseigné",
                        name : [last_name, family_name, first_name].filter(Boolean).join(" ") || "Non renseigné",
                        classe : [
                            student.sectionclass?.class?.short_entitled_class,
                            student.sectionclass?.title,
                            student.sectionclass?.section?.short_entitled_section
                        ].filter(Boolean).join(" ") || "Non renseignée",
                        updated_at :  commitment_date,
                        action : 
                        <span className="table_action">    
                            {
                                this.handleCheck("Modifier élève") == true && (
                                    <button onClick={ () => this.restaure("students", student.id)} className="btn text-primary rounded-3 btn-sm mx-1 p-0 m-0" title="Restaurer cet enregistrement"><FeatherIcon icon="user-check" size={"10"}></FeatherIcon> </button>
                                )
                            }
                            {
                                this.handleCheck("Supprimer élève") == true && (
                                    <button onClick={ () => this.delete("students", student.id)} className="btn text-danger rounded-3 btn-sm mx-1 p-0 m-0" title="supprimer definitivement cet enregistrement"><FeatherIcon icon="user-x" size={"10"}></FeatherIcon> </button>
                                )
                            }
                            </span>,
                    }
                )
            })

            this.setState({
                rowstudents : rows
            })
        }
    }

    async getDataparentfamilies(){
        var data = await axios.get("parentfamilies/operation/Supprimer");
        if(data.status === 200)
        {
            var rows = [];
            data.data.map((parentfamily) => {
                var commitment_date = this.formatDate(parentfamily.updatedAt);
                var last_name = parentfamily.user ? parentfamily.user.last_name : "";
                var first_name = parentfamily.user ? parentfamily.user.first_name : "";
                
                rows.push(
                    {
                        id: parentfamily.id,
                        matricule : parentfamily.user?.tel || "Non renseigné",
                        name : [last_name, first_name].filter(Boolean).join(" ") || "Non renseigné",
                        classe : parentfamily.year?.year || "Non renseignée",
                        updated_at : commitment_date ,
                        action : 
                        <span className="table_action">    
                            {
                                this.handleCheck("Modifier parent") == true && (
                                    <button onClick={ () => this.restaure("parentfamilies", parentfamily.id)} className="btn text-primary rounded-3 btn-sm mx-1 p-0 m-0" title="Restaurer cet enregistrement"><FeatherIcon icon="user-check" size={"10"}></FeatherIcon> </button>
                                )
                            }
                            {
                                this.handleCheck("Supprimer parent") == true && (
                                    <button onClick={ () => this.delete("parentfamilies", parentfamily.id)} className="btn text-danger rounded-3 btn-sm mx-1 p-0 m-0" title="supprimer definitivement cet enregistrement"><FeatherIcon icon="user-x" size={"10"}></FeatherIcon> </button>
                                )
                            }
                        </span>,
                    }
                )
            })

            this.setState({
                rowparents : rows
            })
        }
    }

    async getDatastaffs(){
        var data = await axios.get("staffs/operation/Supprimer");
        if(data.status === 200)
        {
            var rows = [];
            data.data.map((staff) => {
                var commitment_date = this.formatDate(staff.updatedAt);
                var last_name = staff.user ? staff.user.last_name : "";
                var first_name = staff.user ? staff.user.first_name : "";
                
                rows.push(
                    {
                        id: staff.id,
                        matricule : staff.user ? (<Link to={'/staffs/'+staff.id}  className="text-decoration-none">{staff.matricule || "Non renseigné"}</Link>) : "Non renseigné",
                        name : [last_name, first_name].filter(Boolean).join(" ") || "Non renseigné",
                        classe : staff.year?.year || "Non renseignée",
                        updated_at : commitment_date ,
                        action : 
                        <span className="table_action">    
                            {
                                this.handleCheck("Modifier personnel") == true && (
                                    <button onClick={ () => this.restaure("staffs", staff.id)} className="btn text-primary rounded-3 btn-sm mx-1 m-0 p-0" title="Restaurer cet enregistrement"><FeatherIcon icon="user-check" size={"10"}></FeatherIcon> </button>
                                )
                            }
                            {
                                this.handleCheck("Supprimer personnel") == true && (
                                    <button onClick={ () => this.delete("staffs", staff.id)} className="btn text-danger rounded-3 btn-sm mx-1 m-0 p-0" title="supprimer definitivement cet enregistrement"><FeatherIcon icon="user-x" size={"10"}></FeatherIcon> </button>
                                )
                            }
                        </span>,
                    }
                )
            })

            this.setState({
                rowstaffs : rows
            })
        }
    }

    async getDatasuppliers(){
        var data = await axios.get("suppliers/operation/Supprimer");
        if(data.status === 200)
        {
            var rows = [];
            data.data.map((supplier) => {
                var commitment_date = this.formatDate(supplier.updatedAt);
                var last_name = supplier.user ? supplier.user.last_name : "";
                var first_name = supplier.user ? supplier.user.first_name : "";
                
                rows.push(
                    {
                        id: supplier.id,
                        matricule : supplier.user?.tel || "Non renseigné",
                        name : [last_name, first_name].filter(Boolean).join(" ") || supplier.name || "Non renseigné",
                        classe : supplier.year?.year || "Non renseignée",
                        updated_at : commitment_date,
                        action : 
                        <span className="table_action">    
                            {
                                this.handleCheck("Modifier fournisseur") == true && (
                                    <button onClick={ () => this.restaure("suppliers", supplier.id)} className="btn btn-outline-primary rounded-3 btn-sm mx-1" title="Restaurer cet enregistrement"><FeatherIcon icon="user-check" size={"10"}></FeatherIcon> </button>
                                )
                            }
                            {
                                this.handleCheck("Supprimer fournisseur") == true && (
                                    <button onClick={ () => this.delete("suppliers", supplier.id)} className="btn btn-outline-danger rounded-3 btn-sm mx-1" title="supprimer definitivement cet enregistrement"><FeatherIcon icon="user-x" size={"10"}></FeatherIcon> </button>
                                )
                            }
                        </span>,
                    }
                )
            })

            this.setState({
                rowsuppliers : rows
            })
        }
    }

    async getDataprofiles(){
        var data = await axios.get("profiles/operation/Supprimer");
        if(data.status === 200)
        {
            var rows = [];
            data.data.map((profile) => {
                var commitment_date = this.formatDate(profile.updatedAt);
                
                rows.push(
                    {
                        id: profile.id,
                        profile : profile.profile || "Profil sans nom",
                        updated_at : commitment_date,
                        action : 
                        <span className="table_action">    
                            {
                                this.handleCheck("Modifier profil") == true && (
                                    <button onClick={ () => this.restaure("profiles", profile.id)} className="btn btn-outline-primary rounded-3 btn-sm mx-1" title="Restaurer cet enregistrement"><FeatherIcon icon="corner-up-left" size={"10"}></FeatherIcon> </button>
                                )
                            }
                            {
                                this.handleCheck("Supprimer profil") == true && (
                                    <button onClick={ () => this.delete("profiles", profile.id)} className="btn btn-outline-danger rounded-3 btn-sm mx-1" title="supprimer definitivement cet enregistrement"><FeatherIcon icon="x-octagon" size={"10"}></FeatherIcon> </button>
                                )
                            }       
                    </span>,
                    }
                )
            })

            this.setState({
                rowsprofiles : rows
            })
        }
    }

    delete = (model, data) =>{
        if(!window.confirm("Supprimer définitivement cet élément ? Cette action est irréversible.")) return
        axios.delete(model+"/"+data).then((response) => {
            this.setState({
                rowstudents : [],
                rowstaffs : [],
                rowparents : [],
                rowsuppliers : [],
                rowsprofiles : [],
            })
            this.getDatastudents()
            this.getDataparentfamilies()
            this.getDatastaffs()
            this.getDatasuppliers()
            this.getDataprofiles()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error)=>{
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }


    restaure = (model, data) =>{
        axios.put("restaure/"+ model +"/" +data).then((response) => {
            this.setState({
                rowstudents : [],
                rowstaffs : [],
                rowparents : [],
                rowsuppliers : [],
                rowsprofiles : [],
            })
            this.getDatastudents()
            this.getDataparentfamilies()
            this.getDatastaffs()
            this.getDatasuppliers()
            this.getDataprofiles()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error)=>{
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }

  handleCheck(val) {
    var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
     return  permissions.some(item => val === item.permission);
 }

    renderPanel = (title, subtitle, icon, rows, columns, wide = false) => (
        <section className={`trash-panel${wide ? " trash-panel--wide" : ""}`}>
            <header><span><FeatherIcon icon={icon} size={18}/></span><div><h2>{title}</h2><p>{subtitle}</p></div><b>{rows.length}</b></header>
            {this.state.loading ? <div className="trash-state"><FeatherIcon className="user-search-spin" icon="loader" /></div> : rows.length ? <div className="trash-list"><Listprint rows={rows} columns={columns} title={title}/></div> : <div className="trash-state trash-state--empty"><FeatherIcon icon="check-circle" size={25}/><strong>Cette corbeille est vide</strong><small>Aucun élément supprimé dans cette catégorie.</small></div>}
        </section>
    )

    render(){
        const total = this.state.rowstudents.length + this.state.rowparents.length + this.state.rowstaffs.length + this.state.rowsuppliers.length + this.state.rowsprofiles.length
        const parentColumns = this.state.columns.map((column) => column.field === "matricule" ? {...column, label: "Téléphone"} : column.field === "classe" ? {...column, label: "Année"} : column)
        const staffColumns = this.state.columns.map((column) => column.field === "classe" ? {...column, label: "Année"} : column)
        const supplierColumns = parentColumns.map((column) => column.field === "name" ? {...column, label: "Fournisseur"} : column)
        const profileColumns = [{label:'Profil',field:'profile',sort:'asc',width:150},{label:'Date',field:'updated_at',sort:'asc',width:120},{label:'',field:'action',sort:'disabled',width:90,printable:false}]
        return <main className="container trash-page">
            <Helmet><title>{process.env.REACT_APP_NAME} | Corbeille</title></Helmet>
            <header className="trash-hero"><div><span><FeatherIcon icon="archive" size={14}/>Administration RH</span><h1>Corbeille</h1><p>Restaurez les éléments supprimés par erreur ou effacez-les définitivement avec prudence.</p></div><nav><Link to="/manuel#trash"><FeatherIcon icon="book-open" size={17}/>Doc</Link><button type="button" onClick={this.refresh} disabled={this.state.loading}><FeatherIcon icon="refresh-cw" size={17}/>Actualiser</button></nav></header>
            <section className="trash-summary" aria-label="Résumé de la corbeille"><article><i><FeatherIcon icon="trash-2"/></i><b>{total}<small>Éléments supprimés</small></b></article><article><i><FeatherIcon icon="users"/></i><b>{this.state.rowstudents.length + this.state.rowparents.length + this.state.rowstaffs.length}<small>Personnes</small></b></article><article><i><FeatherIcon icon="briefcase"/></i><b>{this.state.rowsuppliers.length}<small>Fournisseurs</small></b></article><article><i><FeatherIcon icon="shield"/></i><b>{this.state.rowsprofiles.length}<small>Profils</small></b></article></section>
            {this.state.error && <div className="trash-alert"><FeatherIcon icon="alert-circle" size={18}/><span>{this.state.error}</span><button type="button" onClick={this.refresh}>Réessayer</button></div>}
            <div className="trash-grid">
                {this.renderPanel("Élèves", "Dossiers scolaires supprimés", "user", this.state.rowstudents, this.state.columns, true)}
                {this.renderPanel("Parents", "Responsables et tuteurs", "user-check", this.state.rowparents, parentColumns)}
                {this.renderPanel("Personnel", "Collaborateurs supprimés", "briefcase", this.state.rowstaffs, staffColumns)}
                {this.renderPanel("Fournisseurs", "Prestataires supprimés", "truck", this.state.rowsuppliers, supplierColumns)}
                {this.renderPanel("Profils", "Rôles et autorisations", "shield", this.state.rowsprofiles, profileColumns)}
            </div>
            <Section formatDate={this.formatDate}/>
        </main>
    }
}

export default Trash;
